
import './App.css';
import Mainroutes from './Pages/Mainroutes';
import LandingPageBody  from "./components/Banner/Banner"
import LandingPagemain from './components/LandingPagemain';
function App() {
  return (
    <Mainroutes/>
    // <LandingPageBody />
    // <LandingPagemain/>
  );
}

export default App;
